@if (isLoading) {
  <div class="loading" [attr.rdd-mode]="cockpitDisplayStateService._displayState === 'rdd' ? 'true' : 'false'">
    <svg xmlns="http://www.w3.org/2000/svg" height="909" version="1.2" viewBox="0 0 1000 909" width="1000">
      <style>
        /* No-freeze v3: two visible segments + two gaps to ensure constant gaps; faster cycle (6s) */
        .left,
        .right {
          fill: none !important;
          stroke: #2b546b;
          stroke-width: 6;
          stroke-linecap: round;
          stroke-linejoin: round;
          vector-effect: non-scaling-stroke;
          animation: serpent 6s linear infinite;
          will-change: stroke-dashoffset;
        }
        .left {
          stroke-dasharray: 0.425 0.075 0.425 0.075;
          stroke-dashoffset: 1;
        }
        .right {
          stroke-dasharray: 0.4 0.1 0.4 0.1;
          stroke-dashoffset: 1;
        }
        @keyframes serpent {
          0% {
            stroke-dashoffset: 1;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }
      </style>
      <title>Final-05</title>
      <defs>
        <linearGradient gradientTransform="matrix(0,616.303,-304.122,0,1134.879,157.636)" gradientUnits="userSpaceOnUse" id="g1" x2="1">
          <stop offset="0" stop-color="#ffbb00" />
          <stop offset=".275" stop-color="#ff793e" />
          <stop offset=".607" stop-color="#dc288e" />
          <stop offset="1" stop-color="#6706ba" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(0,616.304,-415.929,0,856.202,157.635)" gradientUnits="userSpaceOnUse" id="g2" x2="1">
          <stop offset="0" stop-color="#ffbb00" />
          <stop offset=".275" stop-color="#ff793e" />
          <stop offset=".607" stop-color="#dc288e" />
          <stop offset="1" stop-color="#6706ba" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(138.135,-17.198,19.216,154.349,594.913,246.773)" gradientUnits="userSpaceOnUse" id="g3" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(36.02,-130.81,145.264,40,470.231,294.332)" gradientUnits="userSpaceOnUse" id="g4" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(111.557,4.528,-7.64,188.223,308.761,567.332)" gradientUnits="userSpaceOnUse" id="g5" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(-111.557,4.528,-7.64,-188.223,691.402,567.332)" gradientUnits="userSpaceOnUse" id="g6" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(-92.832,-8.866,6.18,-64.709,372.119,345.942)" gradientUnits="userSpaceOnUse" id="g7" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
        <linearGradient gradientTransform="matrix(-75.398,-54.041,63.182,-88.152,567.241,465.127)" gradientUnits="userSpaceOnUse" id="g8" x2="1">
          <stop offset="0" stop-color="#000000" stop-opacity="0" />
          <stop offset="1" stop-color="#000000" stop-opacity="1" />
        </linearGradient>
      </defs>
      <style>
        .s0 {
          fill: url(#g1);
        }
        .s1 {
          fill: url(#g2);
        }
        .s2 {
          fill: url(#g3);
        }
        .s3 {
          fill: url(#g4);
        }
        .s4 {
          fill: url(#g5);
        }
        .s5 {
          fill: url(#g6);
        }
        .s6 {
          fill: url(#g7);
        }
        .s7 {
          fill: url(#g8);
        }

        @keyframes draw {
          0% {
            stroke-dashoffset: 1;
          }
          85% {
            stroke-dashoffset: 0;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }
      </style>
      <g id="Layer 1" fill="none">
        <g id="&lt;Group&gt;" fill="none">
          <g id="&lt;Group&gt;" fill="none">
            <g id="&lt;Group&gt;" fill="none">
              <path
                class="s0 left"
                d="m739 246.98v450.62c0 13.53-8.31 25.75-20.87 30.64-12.55 4.9-26.9 1.64-36.03-8.31l-36.03-38.96-0.16-0.33-57.06-61.79c-5.55-6.01-8.64-13.9-8.64-22.09v-82.78h-0.16v-43.16h-62.77c-13.69 0-25.43-7.99-30.65-20.21-5.05-12.23-2.28-26.25 7.18-35.71l74.17-74.83 80.86-81.67 33.92-34.4c9.45-9.78 23.47-12.56 35.7-7.5 12.71 5.21 20.54 16.95 20.54 30.48zm-65.54 219.28v-139.39l-60.48 60.81-17.44 17.44h50.21v61.14h0.16v117.54l27.39 29.84v-147.38z"
                fill-rule="evenodd"
                id="&lt;Compound Path&gt;"
                fill="none"
                pathLength="1"
              />
              <g id="&lt;Group&gt;" fill="none">
                <path
                  class="s1 right"
                  d="m623.9 234.43l-43.04 43.53-0.16 0.16-61.95 62.61-98.8 99.77v156.26c0 8.19-3.08 16.08-8.64 22.09l-57.06 61.79-0.16 0.33-36.03 38.96c-9.13 9.94-23.48 13.21-36.03 8.32-12.55-4.9-20.87-17.12-20.87-30.65v-390.95c0-15.04 12.19-27.22 27.22-27.22h150.48l-64.88 65.7h-47.12v268.51l27.39-29.84v-170.2l95.7-96.68 72.06-72.71h-0.33l0.33-0.32-261.01 0.32v-65.7h339.59c13.37 0 25.27 7.99 30.32 20.22 5.22 12.23 2.45 26.25-7.01 35.7z"
                  id="&lt;Path&gt;"
                  fill="none"
                  pathLength="1"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    @if (isSlow) {
      <p class="text--md text--semibold primary-500">
        Merci pour ta patience. Le chargement peut prendre un peu plus de temps que prévu, mais ne t'inquiète pas, tout est en ordre.
      </p>
    }
  </div>
}
